<script lang="ts">
  import { differenceInDays } from "$app/utils"
  import Goal from "./MyProgress/Goal.svelte"
  import Task from "./MyProgress/Task.svelte"
  import _ from "lodash"
  import { appStore } from "$app/store.svelte"

  interface Props {
    goalData: {
      goals: any[]
      tasks: any[]
      goal_progresses_dates: any
      task_progresses_dates: any
    }
  }

  let props = $props()
  let { goalData }: Props = props

  const current_user = appStore.current_user

  function convertDate(str: string): Date | null {
    if (!str) {
      return null
    } else {
      return new Date(`${str}T00:00:00`)
    }
  }

  appStore.goals = goalData.goals.map((g) => {
    return {
      ...g,
      days_left: differenceInDays(g.expected_at, "today"),
      open_progress: false,
      progress_date: convertDate(goalData.goal_progresses_dates[g.id])
    }
  })

  appStore.tasks = goalData.tasks.map((t) => {
    return {
      ...t,
      days_left: differenceInDays(t.expected_at, "today"),
      open_progress: false,
      progress_date: convertDate(goalData.task_progresses_dates[t.id])
    }
  })

  function updateGoal(goal: GoalType): void {
    let sGoals = appStore.goals
    const index = sGoals.findIndex((g) => g.id === goal.id)
    const prevGoal = sGoals[index]
    const newGoal = { ...prevGoal, ...goal }
    sGoals[index] = newGoal
    appStore.goals = sGoals
  }

  function updateTask(task: TaskType): void {
    let sTasks = appStore.tasks
    const index = sTasks.findIndex((t) => t.id === task.id)
    const prevTask = sTasks[index]
    const newTask = { ...prevTask, ...task }
    sTasks[index] = newTask
    appStore.tasks = sTasks
  }
</script>

<h2 class="text-2xl mt-8 mb-4 text-left">
  Goals & Tasks Assigned to Your Departments
</h2>

<div class="goals">
  {#each _.sortBy(appStore.goals, "assignee_name") as goal}
    <Goal {goal} />
  {:else}
    <div
      class="w-full text-center p-4 border border-gray-200 bg-gray-50 font-bold"
    >
      You have no goals assigned to your departments
    </div>
  {/each}
</div>

<h2 class="text-2xl mt-6 mb-4 text-left">Tasks Assigned to You</h2>

<div class="tasks mt-4">
  {#each appStore.tasks.filter((t) => t.assignee_id === current_user.id) as task}
    <Task {task} onupdate={(data) => updateTask(data)} />
  {:else}
    <div
      class="w-full text-center p-4 border border-gray-200 bg-gray-50 font-bold"
    >
      You have no tasks assigned to you.
    </div>
  {/each}
</div>
